import { prefix } from '@root/utils/Lang';

const modulePrefix = 'module.shippingMethod';

const translations = {
    'shippingMethod': 'Szállítási módok',
    'edit.title': 'Szállítási mód szerkesztése',
    'id.title': 'ID',
    'name.title': 'Megnevezés',
    'name.hint': 'Ezen a néven jelenik meg a webshopban is',
    'is_active.title': 'Aktív',
    'is_active.hint': 'Csak az aktív szállítási mód jelenik meg a webshopban',
    'sort.title': 'Sorrend',
    'sort.hint': 'Ebben a sorrendben jelenik meg a webshopban',
    'price.title': 'Ár',
    'price.hint': 'Forint',
    'max_weight.title': 'Kosárlimit',
    'max_weight.hint': 'Egy vásárló által egyszerre (egy időpontra) leadható megrendelés maximális tömege gramban',
    'description.title': 'Leírás',
    'description.hint': 'Szállítási információk aloldalon jelenik meg',
    'short_description.title': 'Rövid leírás',
    'short_description.hint': 'Checkoutban jelenik meg',
    'delivery_time.title': 'Szállítási idő',
    'delivery_time.hint': 'Checkoutban jelenik meg (kivéve GRoby futár)',
    'price_ranges.title': 'Ársávok',
    'price_ranges_field.from': 'Összeghatár',
    'price_ranges_field.price': 'Ár',
};

export default prefix(modulePrefix, translations);



// WEBPACK FOOTER //
// ./src/modules/ShippingMethod/lang/hu.ts